import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

interface Props {
  onClose: () => void
  onSuccess: (success: boolean) => void
}

const SAMLDisabled = ({ onClose, onSuccess }: Props) => {
  const handleSubmit = async () => {
    const api = ApiClient()

    const { success } = await asyncAction(() => api.del('/cognito/saml'), { successFlash: false })
    onSuccess(success)
  }

  return (
    <Modal
      illustration="document-edit"
      onClose={onClose}
      onSubmit={() => handleSubmit()}
      title={i18n.t('settings.edit_company.saml_sso.modal.activated.title')}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('settings.edit_company.saml_sso.modal.buttons.cancel')}
          </Button>
          <Button submit>
            {i18n.t('settings.edit_company.saml_sso.modal.buttons.deactivate')}
          </Button>
        </>
      }
    >
      <Box gap="s24" flexDirection="column" alignItems="center">
        <Box
          paddingX="s24"
          paddingY="s16"
          background="grey400"
          borderRadius={{
            all: 'abs008',
          }}
        >
          <Text.Normal>
            {i18n.t('settings.edit_company.saml_sso.modal.activated.description')}
          </Text.Normal>
        </Box>
      </Box>
    </Modal>
  )
}

export default observer(SAMLDisabled)
